<button hidden="true" #statusButton (click)="changeStatus()"></button>
<div class="row py-5 border-bottom">

  <div class="col-md-6 col-xl-6">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
      Reglamento<br>De Caja
    </button>
  </div>
  
  <div class="col-md-6 col-xl-6">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
      Compañías<br>Incluidas
    </button>
  </div>
  
  <div class="col-md-6 col-xl-6 mt-2" *ngIf="originalDRDistributionValue">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 3"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 3" (click)="switchTo(3)">
      Reparto de<br>rendimientos
    </button>
  </div>

  <div class="col-md-6 col-xl-6 mt-2">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 4"
      [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 4" (click)="switchTo(4)">
      Rendimientos<br>&nbsp;
    </button>
  </div>
</div>

<div *ngIf="contentLocation.savingParametersIndex == 0">

  <div class="row ml-1 mr-1 my-5 border">
    <div class="col-md-12">
      <div class="file-upload">
        <label>
          <div class="icon my-5">
            <i class="material-icons">file_upload</i>
          </div>
          <input type="file" (change)="detectFiles($event, 'fileSura')" multiple>
        </label>

        <h6 class="my-5 text-center">
          Reglamento:
          <a *ngIf="downloadURL; else noURL" href="{{downloadURL}}" target="_blank">
            {{modParameter.savingParameter.fileUploaded.name}}
          </a>
          <ng-template #noURL>

            <span *ngIf="modParameter.savingParameter.fileUploaded.name; else noFileSelected">
              {{modParameter.savingParameter.fileUploaded.name}}
            </span>
            <ng-template #noFileSelected>
              <span>
                No se ha seleccionado ningún archivo
              </span>
            </ng-template>

          </ng-template>

        </h6>

      </div>
    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 2">

  <div class="row" *ngIf="logicService.dataManager.generalDataLoader.companies">

    <div class="col-md-12">

      <mat-table #companiesTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.companies">


        <ng-container matColumnDef="companyID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="taxationIdentificationNumber">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Compañía
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionCompanies.toggle(row) : null"
              [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
      </mat-table>

    </div>

  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 3">

  <div *ngIf="iRStatus === 'accumulating'" class="row">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Cálculando rendimientos...</h6>
  </div>

  <div *ngIf="iRStatus === 'creatingFile'" class="row">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Generando archivo de validación</h6>
  </div>

  <div *ngIf="iRStatus === 'fileCreated'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Archivo de validación generado</h6>
    <div class="row mb-5">
      <div class="col-md-3"></div>
      <button *ngIf="iRFileLink" class="col-md-6 btn btn-block btn-primary" (click)="downloadIRFile()">DESCARGAR ARCHIVO</button>
      <div class="col-md-3"></div>

    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4">
          <button (click)="cancelInvestmentReturn(true)" class="btn btn-block btn-outline-secondary">Cancelar repartición</button>
      </div>
      <div class="col-md-4">
          <button (click)="distributeDR()" class="btn btn-block btn-primary">Repartir rendimientos</button>
      </div>
    </div>
  </div>

  <div *ngIf="iRStatus === 'distributingDR'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Repartiendo rendimientos...</h6>
  </div>

  <div *ngIf="iRStatus === 'savingRecordCards'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Guardando fichas ...</h6>
  </div>

  <div *ngIf="iRStatus === 'finished'">
    <h6 class="col mt-5 mb-5" style="text-align: center;">Repartición terminada</h6>
  </div>

  <div *ngIf=" ['recordCardError','m4HttpCodeError','m4StatusError','m4RequestError'].includes(iRStatus)">
    <h6 class="col mt-5 mb-5" style="text-align: center;"> {{iRStatus}} Ha ocurrido una intermitencia, favor de contactar al administrador</h6>
  </div>
  
  <div *ngIf="!iRStatus">
    <mat-form-field class="col-md-12">
      <span matPrefix>$&nbsp;</span>
  
      <input matInput placeholder="Rendimiento:" type="number" [(ngModel)]="revenueAmount" required>
    </mat-form-field>
  
    <div class="row">
      <div class="col-md-4 offset-md-4">
          <button (click)="cancelInvestmentReturn()" class="btn btn-block btn-outline-secondary">Cancelar</button>
      </div>
      <div class="col-md-4">
          <button (click)="calculateDR()" class="btn btn-block btn-primary">Calcular</button>
      </div>
    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 4">
  <mat-radio-group [(ngModel)]="modParameter.hasDRDistribution" class="radio-group">
    <mat-radio-button [value]="true">Habilitar distribución de rendimientos</mat-radio-button>
    <mat-radio-button [value]="false">Deshabilitar distribución de rendimientos</mat-radio-button>
  </mat-radio-group>
</div>
